export const validTaxClassificationTypes = ['INP', 'CCO', 'SCO', 'PRT', 'TRE', 'LLC', 'OTH'];